<div class="files-toolbar">
  <button
    andButton
    color="secondary"
    size="small"
    [dataSelector]="'cxp-deliverable-detail-download-all'"
    [disabled]="files().length === 0 || actionsService.isDownloadingAll()"
    [isLoading]="actionsService.isDownloadingAll()"
    (click)="onDownloadAllClicked()"
  >
    <aiwyn-icon name="download" class="me-1 icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>
    Download All
  </button>
</div>

<div class="files-list" [dataSelector]="'cxp-deliverable-detail-files-list'">
  @for (file of files(); track file.id) {
    <cxp-deliverable-file-row [deliverableId]="deliverableId()" [file]="file" />
  } @empty {
    <p class="files-empty" [dataSelector]="'cxp-deliverable-detail-files-empty'">No files attached.</p>
  }
</div>
